<div class="card atividade-ref-card-info" *ngIf="atividade"
    [class.atividade-concluida]="config?.isConcluida"
    [class.atividade-atrasada]="config?.isAtrasada"
    [class.atividade-pendente]="config?.isPendente">
    <div class="card-header">
        <h6 class="card-title">
            <span *ngIf="config?.isOrigemRetorno">
                <i class="fas fa-retweet"></i> Atividade de Retorno
            </span>
            <span *ngIf="!config?.isOrigemRetorno">
                Atividade
            </span>
            #{{atividade.id}}
        </h6>

        <h6 class="card-title">
            <span *ngIf="config?.isConcluida">Concluída</span>
            <span *ngIf="config?.isAtrasada">Atrasada</span>
            <span *ngIf="config?.isPendente">Pendente</span>
        </h6>
    </div>

    <div class="card-body">
        <ul class="list-group">
            <li class="list-group-item" *ngIf="atividade.titulo">
                <span class="list-group-item-value">
                    <i [class]="atividade.tipo | atividadeTipoIcon" aria-hidden="true"></i>
                    {{atividade.titulo}}
                </span>
            </li>
            <li class="list-group-item" *ngIf="atividade.idUsuarioDestino">
                <span class="list-group-item-title">
                    Responsável
                </span>
                <span class="list-group-item-value">
                    <sgt-avatar
                        [settings]="{
                            isShowLabelNameRight: true,
                            fullName: atividade.nomeUsuarioDestino,
                            imageUrl: atividade.avatarURLUsuarioDestino
                        }">
                    </sgt-avatar>
                </span>
            </li>
            <li class="list-group-item">
                <span class="list-group-item-title">
                    Emissão
                </span>
                <span class="list-group-item-value">
                    {{atividade.dataEmissao | date:'dd/MM/yyyy'}} às {{atividade.dataEmissao | date:'HH:mm'}}
                </span>
            </li>
            <li class="list-group-item">
                <span class="list-group-item-title">
                    Prazo
                </span>
                <span class="list-group-item-value">
                    {{atividade.diaPrazo | date:'dd/MM/yyyy'}} {{atividade.horaPrazo ? 'às ' + (atividade.horaPrazo | date:'HH:mm') : ''}}
                </span>
            </li>
            <li class="list-group-item" *ngIf="atividade.comentario">
                <span class="list-group-item-title">
                    Comentário
                </span>
                <span class="list-group-item-value">
                    {{atividade.comentario}}
                </span>
            </li>

            <ng-template [ngIf]="atividade.dataConclusao">
                <li class="list-group-item">
                    <span class="list-group-item-title">
                        Concluída Em
                    </span>
                    <span class="list-group-item-value">
                        {{atividade.dataConclusao | date:'dd/MM/yyyy'}} às {{atividade.dataConclusao | date:'HH:mm'}}
                    </span>
                </li>
                <li class="list-group-item" *ngIf="atividade.idUsuarioConclusao">
                    <span class="list-group-item-title">
                        Concluída Por
                    </span>
                    <span class="list-group-item-value">
                        <sgt-avatar
                            [settings]="{
                                isShowLabelNameRight: true,
                                fullName: atividade.nomeUsuarioConclusao,
                                imageUrl: atividade.avatarURLUsuarioConclusao
                            }">
                        </sgt-avatar>
                    </span>
                </li>
            </ng-template>
        </ul>
    </div>
    <div class="card-footer">
        <button type="button" class="btn btn-link" (click)="openAtividade.emit(atividade)">
            <i class="fas fa-external-link-alt"></i> Abrir {{config?.isOrigemRetorno ? 'Retorno' : 'Atividade'}}
        </button>
    </div>
</div>
